module.exports = __webpack_public_path__ + "img/hat_4.afb760ce.png";